export default __webpack_public_path__ + "f6760d171238d9ddd8b38f351f2c2851.png";